import React from "react";
import { Label } from "./Label";
import { VersusDivider } from "./VersusDivider";

export const MarketCompetitor = ({
  hasMultipleCompetitors,
  competitor,
  competitors,
  buttonOnly,
  type,
  league,
  sport,
  competitionType,
  mode,
  showVersusDivider,
  hasScore,
  isOddsBoost,
  name,
}) => {
  return hasMultipleCompetitors ? (
    <div className="cui-w-full cui-flex cui-flex-col cui__market-competitor-wrapper">
      <Label
        competitor={competitors[0]}
        hasMultipleCompetitors={hasMultipleCompetitors}
        name={name}
        buttonOnly={buttonOnly}
        type={type}
        league={league}
        sport={sport}
        competitionType={competitionType}
        mode={mode}
      />
      {showVersusDivider ? (
        <VersusDivider hasScore={hasScore} asBlock show={showVersusDivider} />
      ) : null}
      <Label
        competitor={competitors[1]}
        hasMultipleCompetitors={hasMultipleCompetitors}
        name={name}
        buttonOnly={buttonOnly}
        type={type}
        league={league}
        sport={sport}
        competitionType={competitionType}
        mode={mode}
      />
    </div>
  ) : (
    <Label
      competitor={competitor}
      hasMultipleCompetitors={hasMultipleCompetitors}
      name={name}
      buttonOnly={buttonOnly}
      type={type}
      league={league}
      sport={sport}
      competitionType={competitionType}
      mode={mode}
      isOddsBoost={isOddsBoost}
    />
  );
};
